import type { RouterResolverGateProps } from "./router-resolver-gate.type";

import { Navigate } from "react-router";

import { useGetResolverPath } from "./router-resolver-gate.hook";

export const RouterResolverGate = ({
  routes,
  children,
}: RouterResolverGateProps) => {
  const { redirectTo } = useGetResolverPath(routes);

  if (redirectTo) return <Navigate to={redirectTo} replace />;

  return children;
};
